import type { CreateOneShopExportDto, ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type AddExportMethodParams = {
	shopExport: CreateOneShopExportDto;
};

type UseAddExportMethodParams = {
	onSuccess?: () => void;
};

export default function useAddExportMethod(
	shop: ShopDto,
	params?: UseAddExportMethodParams,
) {
	return useApiMutation("post", "/shops/{shopId}/exports", {
		invalidate: useInvalidateShop(shop.id),
		onSuccess: params?.onSuccess,
		mapVariables: ({ shopExport }: AddExportMethodParams) => ({
			params: { path: { shopId: shop.id } },
			body: shopExport,
		}),
	});
}
